export default {
	init() {

		let filterWrapper = $('.filterWrapper')

		filterWrapper.on('click', 'h3, h4', function() {
			$(this).closest('.filterWrapper').toggleClass('in-view')
		})


		// Shop filters
		let filterWrapperBlock = $('.filterWrapper-block')
		filterWrapperBlock.on('click', '.filterBlock-expander', function() {
			$(this).closest('.filterWrapper-block').toggleClass('in-view')
		})

	}
}
